/**
 * Takes a name and attempts to split it to first name and last name.
 *
 * @param {string} [name] The name.
 * @returns {{firstName: string, lastName: string}}
 */
export const getAccountFirstLastNameFromString = name => {
  if (!name) {
    return {
      firstName: '',
      lastName: '',
    };
  }

  const nameArray = name.trim().split(' ');
  const lastName = nameArray.length > 1 ? nameArray.pop() : '';
  const firstName = nameArray.join(' ').trim();

  return {
    firstName: firstName === 'Me' || !firstName ? '' : firstName,
    lastName: lastName.trim(),
  };
};
